import React, { useState, useRef } from 'react';
import { FormView, Field } from '../../components/form/Index';
import Button from '@material-ui/core/Button';
import { SearchEvents } from '../../REST/cameraEvents';
import { GetCompanyInvoiceByDotNumber } from '../../REST/statement';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SimpleCheckBox } from '../../components/checkbox';
import { simpleDateTime } from '../../components/dates';
import CreateInvoice from '../Statements/create';
import { useHistory } from 'react-router-dom';
import MessageView from '../../components/message';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Search() {
    const classes = useStyles();
    const [searchBy, setSearchBy] = useState('events');
    const [search, setSearch] = useState({});
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dotNumber, setDotNumber] = useState('');
    const [invoiceResults, setInvoiceResults] = useState([]);
    const [filters, setFilters] = useState({
        invoiceNumber: '', invoiceCycle: '', companyName: '', dotnumber: '',
        fiscalYear: '', status: '', invoiceDate: '', dueDate: '', paidDate: '', amountDue: ''
    });
    const formView = useRef(null);
    const history = useHistory();

    const handleChange = () => {
        let result = formView.current.getCurrentResult();
        setSearch({ ...search, ...result })
    }

    const handleSearch = () => {
        let result = formView.current.getResult();
        if (result) {
            if (result.vehicleType === '1' || result.vehicleType === 1)
                result.plateRegion = 'AZ';
            SearchEvents(result).then(response => {
                if (Array.isArray(response.data))
                    setResults(response.data)
            })
        }
    }

    const options = [
        { label: 'Commercial Ground', value: 2 },
        { label: 'Aircraft', value: 1 },
    ]

    return <div className='row'>
        <ResultsView handleClose={() => setResults([])} results={results} open={results.length > 0} />
        <Backdrop className={classes.backdrop} open={loading} onClick={() => setLoading(false)}><CircularProgress color="inherit" /></Backdrop>
        <div className='col-xs-12 col-sm-6 offset-sm-3'>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                <FormControl component='fieldset'>
                    <FormLabel component='legend' style={{ textAlign: 'center', marginBottom: 4 }}>Search By</FormLabel>
                    <RadioGroup
                        row
                        value={searchBy}
                        onChange={(e) => {
                            setSearchBy(e.target.value);
                            setDotNumber('');
                        }}
                    >
                        <FormControlLabel value='events' control={<Radio color='secondary' />} label='Search Events' />
                        <FormControlLabel value='invoices' control={<Radio color='secondary' />} label='Search Invoices' />
                    </RadioGroup>
                </FormControl>
            </div>

            {searchBy === 'events' && (
                <>
                    <h4 className='lead text-center'>Search For Events</h4>
                    <FormView ref={formView} data={search}>
                        <Field.DropDown changeEvt={handleChange} options={options} field='vehicleType' label='Transport Type' required />
                        <Field.TextBox field='plateNumber' label='Plate/Tail Number' required />
                        {search && (search.vehicleType === 2 || search.vehicleType === '2') && <Field.DropDown options={states} field='plateRegion' label='Plate Region' required />}
                       {/* <div className='row'>
                            <Field.DatePicker className='col' label='Date From' field='startDate' required />
                            <Field.DatePicker className='col' label='Date To' field='endDate' required />
                    </div>*/}
                        <Button fullWidth color='secondary' onClick={handleSearch} variant='outlined'>Search</Button>
                    </FormView>
                </>
            )}

            {searchBy === 'invoices' && (
                <>
                    <h4 className='lead text-center'>Search Invoices by DOT Number</h4>
                    <TextField
                        fullWidth
                        variant='outlined'
                        label='DOT Number'
                        value={dotNumber}
                        onChange={(e) => setDotNumber(e.target.value)}
                        style={{ marginBottom: 16 }}
                    />
                    <Button
                        fullWidth
                        color='secondary'
                        variant='outlined'
                        disabled={!dotNumber.trim()}
                        onClick={() => {
                            GetCompanyInvoiceByDotNumber(dotNumber.trim()).then(response => {
                                console.log(response.data[0])
                                if (Array.isArray(response.data))
                                    setInvoiceResults(response.data);
                                else
                                    setInvoiceResults([]);
                            });
                        }}
                    >
                        Search
                    </Button>
                </>
            )}
        </div>

        {searchBy === 'invoices' && invoiceResults.length > 0 && (
            <div className='col-12' style={{ marginTop: 24 }}>
                <TableContainer component={Paper}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell><b>View Invoice</b></TableCell>
                                <TableCell><b>Invoice Number</b></TableCell>
                                <TableCell><b>Invoice Cycle / Permit Type</b></TableCell>
                                <TableCell><b>Company Name</b></TableCell>
                                <TableCell><b>DOT Number</b></TableCell>
                                <TableCell><b>Fiscal Year</b></TableCell>
                                <TableCell><b>Status</b></TableCell>
                                <TableCell><b>Invoice Date</b></TableCell>
                                <TableCell><b>Due Date</b></TableCell>
                                <TableCell><b>Payment Date</b></TableCell>
                                <TableCell align='right'><b>Amount Due</b></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell />
                                {['invoiceNumber', 'invoiceCycle', 'companyName', 'dotnumber', 'fiscalYear', 'status', 'invoiceDate', 'dueDate', 'paidDate', 'amountDue'].map(key => (
                                    <TableCell key={key} style={{ padding: '4px 8px' }}>
                                        <TextField
                                            size='small'
                                            variant='standard'
                                            placeholder='Filter'
                                            value={filters[key]}
                                            onChange={(e) => setFilters({ ...filters, [key]: e.target.value })}
                                            fullWidth
                                        />
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {invoiceResults
                                .filter(row => {
                                    return Object.keys(filters).every(key => {
                                        if (!filters[key]) return true;
                                        const val = row[key] != null ? String(row[key]) : '';
                                        return val.toLowerCase().includes(filters[key].toLowerCase());
                                    });
                                })

                                .map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>
                                        {row.id && (
                                            <Button
                                                size='small'
                                                color='secondary'
                                                variant='contained'
                                                onClick={() => window.open('#/statement/' + row.id, '_blank')}
                                            >
                                                {(() => {
                                                    const status = ((row.status || '') + '').trim().toLowerCase();
                                                    const viewStatuses = ['payment reversed', 'cancelled', 'paid'];
                                                    console.log(status)
                                                    return viewStatuses.includes(status) ? 'View' : 'Pay Now';
                                                })()}
                                            </Button>
                                        )}
                                    </TableCell>
                                    <TableCell>{row.invoiceNumber}</TableCell>
                                    <TableCell>{row.invoiceCycle}</TableCell>
                                    <TableCell>{row.companyName}</TableCell>
                                    <TableCell>{row.dotnumber}</TableCell>
                                    <TableCell>{row.fiscalYear}</TableCell>
                                    <TableCell>{row.status}</TableCell>
                                    <TableCell>{row.invoiceDate}</TableCell>
                                    <TableCell>{row.dueDate}</TableCell>
                                    <TableCell>{row.paidDate}</TableCell>
                                    <TableCell align='right'>{row.amountDue != null ? `$${Number(row.amountDue).toFixed(2)}` : ''}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )}
    </div>
}

function ResultsView({ results = [], open = false, handleClose }) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([])
    const [create, setCreate] = useState({ eventIds: [], open: false, groupSimilar: false })
    const history = useHistory();

    const handlePay = () => setCreate({ eventIds: selected, open: true })

    const handleCheck = (item) => {
        const exist = selected.includes(item)
        if (!exist)
            setSelected(selected.concat([item]))
        else setSelected(selected.filter(e => e !== item))
    }

    const handleInvoice = (invoiceIds) => {
        if (invoiceIds.length > 0)
            history.push('/statement/' + invoiceIds[0])
    }

    return (<Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar color='secondary' className={classes.appBar}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                    Select Events
            </Typography>
            </Toolbar>
        </AppBar>
        <CreateInvoice eventIds={create.eventIds} open={create.open} onCreated={handleInvoice} groupSimilar={false} handleClose={() => setCreate({ open: false, eventIds: [] })} />
        <Backdrop className={classes.backdrop} open={loading} onClick={() => setLoading(false)}><CircularProgress color="inherit" /></Backdrop>
        <MessageView setting='SELECT_EVENTS_MESSAGE' title='Select Events' fullScreen={false} />
        <div className='col-12'>
            {
                results.map((e, i) => {
                    return <div key={i} className='row border-top border-bottom pt-3'>
                        <div className='col-8'>
                            <SimpleCheckBox onCheck={() => handleCheck(e.id)} editable={!e.isPaid} checked={selected.includes(e.id)}>
                                <p className='w-100 h6'><small className='text-muted'>Activity: </small>{e.activity}</p>
                                <p className='w-100 h6'><small className='text-muted'>Activity Time: </small> {simpleDateTime(e.activityTime)}</p>
                                <p className='w-100 h6'><small className='text-muted'>Plate Number: </small>{e.plateNumber}</p>
                                <p className='w-100 h6'><small className='text-muted'>Plate Region: </small>{e.plateRegion}</p>
                            </SimpleCheckBox>
                        </div>
                        <div className='col-2 text-right my-auto'>
                            {e.isPaid && <b>Paid</b>}
                        </div>
                        {/*<div className='col-2 text-right my-auto'>
                            <b>${e.charge.toFixed(2)}</b>
                        </div>*/}
                    </div>
                })
            }
            {selected.length > 0 && <Button variant='outlined' size='large' onClick={handlePay}>Pay ({selected.length}) Item(s)</Button>}
        </div>
    </Dialog>
    );
}


const states = [{ "label": "Alabama", "value": "AL" }, { "label": "Alaska", "value": "AK" }, { "label": "American Samoa", "value": "AS" }, { "label": "Arizona", "value": "AZ" }, { "label": "Arkansas", "value": "AR" }, { "label": "California", "value": "CA" }, { "label": "Colorado", "value": "CO" }, { "label": "Connecticut", "value": "CT" }, { "label": "Delaware", "value": "DE" }, { "label": "District Of Columbia", "value": "DC" }, { "label": "Federated States Of Micronesia", "value": "FM" }, { "label": "Florida", "value": "FL" }, { "label": "Georgia", "value": "GA" }, { "label": "Guam", "value": "GU" }, { "label": "Hawaii", "value": "HI" }, { "label": "Idaho", "value": "ID" }, { "label": "Illinois", "value": "IL" }, { "label": "Indiana", "value": "IN" }, { "label": "Iowa", "value": "IA" }, { "label": "Kansas", "value": "KS" }, { "label": "Kentucky", "value": "KY" }, { "label": "Louisiana", "value": "LA" }, { "label": "Maine", "value": "ME" }, { "label": "Marshall Islands", "value": "MH" }, { "label": "Maryland", "value": "MD" }, { "label": "Massachusetts", "value": "MA" }, { "label": "Michigan", "value": "MI" }, { "label": "Minnesota", "value": "MN" }, { "label": "Mississippi", "value": "MS" }, { "label": "Missouri", "value": "MO" }, { "label": "Montana", "value": "MT" }, { "label": "Nebraska", "value": "NE" }, { "label": "Nevada", "value": "NV" }, { "label": "New Hampshire", "value": "NH" }, { "label": "New Jersey", "value": "NJ" }, { "label": "New Mexico", "value": "NM" }, { "label": "New York", "value": "NY" }, { "label": "North Carolina", "value": "NC" }, { "label": "North Dakota", "value": "ND" }, { "label": "Northern Mariana Islands", "value": "MP" }, { "label": "Ohio", "value": "OH" }, { "label": "Oklahoma", "value": "OK" }, { "label": "Oregon", "value": "OR" }, { "label": "Palau", "value": "PW" }, { "label": "Pennsylvania", "value": "PA" }, { "label": "Puerto Rico", "value": "PR" }, { "label": "Rhode Island", "value": "RI" }, { "label": "South Carolina", "value": "SC" }, { "label": "South Dakota", "value": "SD" }, { "label": "Tennessee", "value": "TN" }, { "label": "Texas", "value": "TX" }, { "label": "Utah", "value": "UT" }, { "label": "Vermont", "value": "VT" }, { "label": "Virgin Islands", "value": "VI" }, { "label": "Virginia", "value": "VA" }, { "label": "Washington", "value": "WA" }, { "label": "West Virginia", "value": "WV" }, { "label": "Wisconsin", "value": "WI" }, { "label": "Wyoming", "value": "WY" }]